import cx from 'classnames'
import { forwardRef } from 'react'

import * as styles from './Unread.css'

type UnreadColor = 'red' | 'blue' | 'gray'

interface UnreadProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: UnreadColor
  /**
   * What to show inside the count.
   * Can be either a number (in this case the badge will only be shown if the count is > 0) or a string
   */
  count: number | string
}

const Unread = forwardRef<HTMLDivElement, UnreadProps>(
  ({ className, color = 'red', count, ...props }, ref) => {
    if (typeof count === 'string' || count > 0) {
      return (
        <div ref={ref} className={cx(styles.root({ color }), className)} {...props}>
          {count}
        </div>
      )
    }

    return null
  },
)

export default Unread
